import merge from 'lodash/merge';
import range from 'lodash/range';
import mapValues from 'lodash/mapValues';

import colors from 'open-color/open-color.json';

const emToPx = (em) => `${em * 16}px`;

export const breakpoints = [22, 36, 48, 62, 90, 120].map(emToPx);
export const containerWidth = [22, 36, 46, 60].map(emToPx);
export const mobileOrDesktop = (mobile, desktop) => [mobile, null, null, desktop];

const generateFade = (r, g, b) => range(10, 100, 10)
  .reduce((fade, opacity) => merge(fade, { [opacity]: `rgba(${[r, g, b, opacity / 100].join()})` }), {});

const flatternColors = mapValues(colors, (listOfColors) => listOfColors[5]);

const font = 'Arial, "PingFang TC", "HeiTi TC", "Microsoft JhengHei", sans-serif';

const white = '#fff';
const black = '#000';

export default {
  colors: {
    ...flatternColors,
    white,
    black,
    text: black,
    primary: flatternColors.blue,
    primaryHover: colors.blue[9],
    primaryInvert: white,
    secondary: flatternColors.green,
    secondaryInvert: white,
    warn: flatternColors.red,
    variations: colors,
    gray: '#a5aaaf',
    fade: {
      white: generateFade(255, 255, 255),
      black: generateFade(0, 0, 0),
    },
  },
  breakpoints,
  containerWidth,
  font,
  headerHeight: '4em',
  mobileOrDesktop,
  duration: 300,
  zOrder: range(4).map((i) => 10 ** i),
};
